import { Link } from 'react-router-dom'

import { tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { BackIcon } from '@icons'

import AttentionIcon from '@assets/icons/attention.svg'

import Bullet1 from '@assets/icons/bullet11.svg'
import Bullet2 from '@assets/icons/bullet12.svg'
import Bullet3 from '@assets/icons/bullet13.svg'

import './bankTransferWarning1.scss'

interface BankTransferWarning1Props {
  handleBack?: () => void
  handleNext: () => void
  paymentMethod?: string
  onCancel?: () => void
}

export const BankTransferWarning1 = ({
  handleBack,
  handleNext,
  paymentMethod,
  onCancel
}: BankTransferWarning1Props) => {
  return (
    <div className='bank-transfer-warning1'>
      {typeof handleBack === 'function' ? (
        <div className='back-button-wrapper'>
          <span onClick={handleBack} data-test='back-button'>
            <BackIcon />
            <span>{tr('FRONTEND.BUTTONS.BACK', 'Back')}</span>
          </span>
        </div>
      ) : null}

      <div className='payment-method-wrapper' data-test={`pay-with-${paymentMethod}-warning1`}>
        {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay by {{METHOD}}', {
          METHOD: paymentMethod ? tr(`METADATA.PAYMENT_OPTIONS.${paymentMethod}`, paymentMethod) : ''
        })}
      </div>

      <div className='warning-content'>
        <img src={AttentionIcon} width={90} height={90} alt='' />

        <div className='warning-title'>
          {tr('CHECKOUT.MANUAL.STEP1.TITLE', "We won't take the money from your bank account automatically.")}
        </div>

        <div className='warning-bullet'>
          <img src={Bullet1} alt='' />
          <span>{tr('CHECKOUT.MANUAL.STEP1.BULLET1', "We'll provide you with our bank details.")}</span>
        </div>
        <div className='warning-bullet'>
          <img src={Bullet2} alt='' />
          <span>{tr('CHECKOUT.MANUAL.STEP1.BULLET2', 'You will need to initiate the bank transfer on your own.')}</span>
        </div>
        <div className='warning-bullet'>
          <img src={Bullet3} alt='' />
          <span>{tr('CHECKOUT.MANUAL.STEP1.BULLET3', 'Once we receive the money, we will credit the funds.')}</span>
        </div>
      </div>

      <div className='warning-buttons'>
        <Button
          type='button'
          color='primary'
          text={tr('CHECKOUT.MANUAL.STEP1.CONTINUE_BUTTON', 'I understand')}
          onClick={handleNext}
          data-test='button-confirm'
        />
        {typeof onCancel === 'function' && (
          <div className='cancel-button-container mt-2'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
